import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {scrollToSection} from 'components/ScrollSpy'
import {useCloseTopOverlays} from 'hooks/useCloseTopOverlays/useCloseTopOverlays'
import {
  setLightboxOverlayVisibility,
  setLightboxSelectedImage
} from 'modules/accommodation/slice'
import {AccommodationPageNavSections} from 'modules/accommodation/types'
import {OfferAccessFlow} from 'modules/sapiSearch/constants'
import {getRoomsResult} from 'modules/searchApi/selectors'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  trackOfferClicked: () => void
  flowType: OfferAccessFlow
  // Renders inline, next to price/labels content, instead of stacked below
  // it - used by the compact AP sticky bottom bar.
  isCompact?: boolean
}
const CTAWrapper = styled.div<{isCompact?: boolean}>`
  white-space: nowrap;
  ${({isCompact}) => !isCompact && `min-width: 144px;`}
  margin-top: ${({isCompact}) =>
    isCompact ? 0 : cssTheme.layout.spacing.s400};
`
export const PrimaryRoomOfferCTA = ({
  trackOfferClicked,
  flowType,
  isCompact = false
}: Props) => {
  const dispatch = useDispatch()

  const {isLoading} = useSelector(getRoomsResult)
  const {isMobile} = useDeviceLayout()
  const closeTopOverlays = useCloseTopOverlays()

  const onOfferClick = () => {
    if (isLoading) {
      return
    }

    trackOfferClicked()

    if (!isMobile) {
      dispatch(setLightboxOverlayVisibility(false))
      dispatch(setLightboxSelectedImage(undefined))
    }

    const closedOverlays = closeTopOverlays()

    scrollToSection(AccommodationPageNavSections.Rooms, {
      deferred: closedOverlays > 0
    })
  }
  const shouldDisplayViewDeal = flowType !== OfferAccessFlow.RegularDeal

  const ctaLabel = isCompact ? (
    <FormattedMessageWrapper id="selectRoom" defaultMessage="Select room" />
  ) : shouldDisplayViewDeal ? (
    <FormattedMessageWrapper id="viewDeal" defaultMessage="View deal" />
  ) : (
    <FormattedMessageWrapper id="viewRooms" defaultMessage="View rooms" />
  )

  return (
    <CTAWrapper data-id="OfferCta" isCompact={isCompact}>
      <Button
        variant="primary"
        size="xl"
        fullWidth={!isCompact}
        onClick={onOfferClick}
        iconEnd={
          shouldDisplayViewDeal && (
            <Box hasMirror>
              <Icon name="ChevronRight" />
            </Box>
          )
        }
      >
        {ctaLabel}
      </Button>
    </CTAWrapper>
  )
}
